module.exports = __webpack_public_path__ + "img/stage5.c227dfb9.png";